import { Autocomplete } from 'components/Autocomplete/Autocomplete';
import type { Option } from 'models/option';
import { useTranslations } from 'utils';

import { VisuallyHidden } from '../../../../../../ui/VisuallyHidden/VisuallyHidden';

type Props = {
  className?: string;
  handleChange: (value: string) => void;
  required: boolean;
  selectedOption: string;
  options: Option[];
  placeholder: string;
  name: string;
  error?: string;
  dataTestId?: string;
};

const QuestionsAutocomplete = ({
  handleChange,
  options,
  placeholder,
  required,
  selectedOption,
  name,
  error,
  dataTestId,
  className,
}: Props) => {
  const i18n = useTranslations();
  return (
    <Autocomplete
      name={name}
      onChange={handleChange}
      options={options}
      data-testid={dataTestId}
      selected={selectedOption}
      required={required}
      error={error}
    >
      <Autocomplete.Input
        data-testid={dataTestId}
        placeholder={placeholder}
        className={className}
        labelClassName="line-clamp-none max-w-[calc(100%-2rem)]"
      />
      <Autocomplete.Options />
      {error && typeof error === 'string' && (
        <Autocomplete.Error>
          <VisuallyHidden as="span">{placeholder}</VisuallyHidden>
          {i18n.t(error)}
        </Autocomplete.Error>
      )}
    </Autocomplete>
  );
};

export { QuestionsAutocomplete };
